/**
 * Copyright 2019 Atelier Disko. All rights reserved. This source
 * code is distributed under the terms of the BSD 3-Clause License.
 */

import React, { useState, useEffect } from 'react';
import { withRoute } from 'react-router5';
import { Helmet } from 'react-helmet';
import { useGlobal } from 'reactn';

import './LandingPage.css';
import { Client } from '@atelierdisko/dsk';

function LandingPage(props) {
  const [config] = useGlobal('config');

  return (
    <div className="landing-page">
      <Helmet titleTemplate={`%s – ${props.baseTitle}`} defaultTitle={props.baseTitle}>
        <title>{props.url !== '' && props.identifier}</title>
        <meta name="description" content={props.description} />
      </Helmet>

      <div className="landing-page__docs">
        <div className="landing-page__kicker">{config.org}</div>
        <div className="landing-page__title">{props.title}</div>
        <div className="landing-page__description">{props.description}</div>

        <div className="landing-page__additional">Additional Documentation</div>
        <div className="landing-page__cards">
          {props.title !== 'Developer Documentation' && <LandingPageCard identifier="dev-docs" />}

          {/*{props.title !== 'Design Docs' && <LandingPageCard identifier="design-docs" />}*/}

          {props.title !== 'Design Kit' && <LandingPageCard identifier="design-kit" />}
        </div>
      </div>
    </div>
  );
}

function LandingPageCard(props) {
  const [config] = useGlobal('config');
  const [description, setDescription] = useState(null);
  const [org, setOrg] = useState(null);
  const [title, setTitle] = useState(null);

  useEffect(() => {
    if (!config._populated) {
      return;
    }

    Client.fetch(config.custom.urls[props.identifier] + 'api/v1/tree/').then(data => {
      setDescription(data.description);
    });

    Client.fetch(config.custom.urls[props.identifier] + 'api/v2/hello').then(data => {
      setOrg(data.org);
      setTitle(data.project);
    });
  }, [config]);

  return (
    <a
      className={`landing-page-card landing-page-card--${props.identifier}`}
      href={config._populated && config.custom.urls[props.identifier]}
    >
      <div className="landing-page-card__title">
        {org}
        <br /> <strong>{title}</strong>
      </div>
      <div className="landing-page-card__content">
        <p>{description}</p>
        <div className="landing-page-card__url">{config._populated && config.custom.urls[props.identifier]}</div>
      </div>
    </a>
  );
}

export default withRoute(LandingPage);
